<script>
import AdminLayout from '@layouts/admin-main'
import AccountTransferList from '@components/admin/account-transfer-list'
export default {
  page: {
    title: 'Admin::AccountTransferList',
    meta: [{ name: 'description', content: 'Admin::AccountTransferList' }],
  },
  components: { AdminLayout, AccountTransferList },
}
</script>

<template>
  <AdminLayout>
    <AccountTransferList></AccountTransferList>
  </AdminLayout>
</template>
